<template>

    <div class="pt-5">
        <div class="row justify-content-center">
            <div class="col-9">
                <b-card class="custom py-3">
                    <div class="row">
                        <div class="col-12">
                            <h2>{{ $t('Podgląd kampanii') }}</h2>
                            <div class="mb-2" v-if="element.company !== undefined || element.company !== null ">
                                <p class="h3 mb-0">{{ $t('Nazwa firmy') }}:</p>
                                <span> {{ element.company.title }}</span>
                            </div>
                            <div class="mb-2">
                                <p class="h3 mb-0">{{ $t('Zasięg:') }}</p>
                                <span>
                                     {{$t(element.rangeReadable)}}
                                </span>
                            </div>

                            <div class="mb-2" v-if="element.outposts !== undefined && element.outposts !== null">
                                <p class="h3 mb-0">{{ $t('Placówki: ') }}</p>
                                <span v-for="(outpost,key) in element.outposts" :key="key">
                                    {{ outpost.mainAddress + `, ` + outpost.postalCode + ` ` + outpost.city}}<br>
                                </span>
                            </div>

                            <div class="mb-2" v-if="element.devices !== undefined || element.devices !== null ">
                                <p class="h3 mb-0">{{ $t('Urządzenia: ') }}</p>
                                <span v-for="(device,key) in element.devices" :key="key">
                                    {{ device.unit.unitId}} - {{device.unitLocation.title}}<br>
                                </span>
                            </div>

                            <div class="mb-2" v-if="element.question !== undefined && element.question !== null">
                                <p class="h3 mb-0">{{ $t('Pytanie') }}:</p>
                                <span>{{ element.question }}</span>
                            </div>

                            <div class="mb-2">
                                <p class="h3 mb-0">{{ $t('Data od') }}:</p>
                                <span>{{ element.dateFrom }}</span>
                            </div>

                            <div class="mb-2">
                                <p class="h3 mb-0">{{ $t('Data do') }}:</p>
                                <span>{{ element.dateTo }}</span>
                            </div>
                            <div class="mb-2">
                                <p class="h3 mb-0">{{ $t('Status') }}</p>
                                <span>{{ $t(element.statusReadable) }}</span>
                            </div>

                        </div>

                    </div>

                    <b-card-text>
                        <div class="row">

                        </div>
                    </b-card-text>
                </b-card>
                <div class="wrapper-btn my-3 d-flex justify-content-end">
                    <b-button
                            :to="{name:'admin.campaigns'}"
                            variant="secondary"
                            class="custom px-5 mr-3">
                        {{ $t('Wróć') }}
                    </b-button>

                    <b-button
                            v-if="checkIfVisible()"
                            :to="{ name: 'admin.campaign', params: {id: companyId} }"
                            variant="primary"
                            class="custom px-5">
                        {{ $t('Edycja') }}
                    </b-button>

                </div>
            </div>
        </div>

    </div>

</template>

<script>
import { checkUserPermissions } from '@/config/AppConfig'

export default {
  name: 'campaignPreview',
  components: {},
  data () {
    return {
      returnPath: 'admin.campaigns',
      permissionParam: 'edit_campaign',
      element: []
    }
  },
  methods: {
    checkIfVisible () {
      if (this.permissionParam !== undefined && this.permissionParam !== null) {
        return checkUserPermissions(this.permissionParam)
      }
      return true
    }
  },
  computed: {
    companyId () {
      return this.$route.params.id
    }
  },
  mounted () {
    if (this.companyId !== undefined && this.companyId !== null && this.companyId !== '') {
      this.$store.dispatch('getCampaign', { id: this.companyId }).then(response => {
        if (response.id === undefined) {
          this.$router.push({ name: this.returnPath })
        }
        this.element = response
      })
    }
  }
}
</script>

<style scoped>

</style>
